// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202603311433/js/" + chunkId + "." + {"44":"5572bc2a","225":"ad735652","481":"23da5c6b","486":"398b78c2","770":"1b09fddc"}[chunkId] + ".0.9788122809310877.chunk.js";
};